import React from 'react'
import { Icon } from 'antd'
export default {
  "fields": [
    [
      {
        "title": "Nome",
        "key": "name",
        "type": "text",
        "element-attr": { "required": true, "prefix": <Icon type="tags" />}
      },
      {
        "title": "Valor",
        "key": "value",
        "type": "number",
        "element-attr": { "required": false, "prefix": <Icon type="tags" />, min: 0, max: 100}
      }
    ]
  ],
  "submit": {
    "collection": "TechManager"
  },
  "className": "config-component",
  "schema": [
    {
      "title": "Nome",
      "key": "name",
      "dataIndex": "name",
      "type": "text",
      className: "name"
    },
    {
      title: "Valor",
      key: 'value',
      dataIndex: 'value',
      type: "render",
      render: r => `${r}%`
    }
  ],
  "title-navigation": <div><Icon type="user" /> Responsável Técnico</div>,
  "title-module": "Responsável Técnico",
  "module": "TechManager",
  "router-base": "/panel/responsavel-tecnico"
}

